import { createSelector } from 'reselect';
import _ from 'lodash';

const getBoards = state => state.boards;

export const boardsProviderKeysSelector = createSelector([getBoards], boards =>
  _.keyBy(boards, 'provider_id')
);

export const boardsIdKeysSelector = createSelector([getBoards], boards =>
  _.keyBy(boards, 'id')
);
export const customBoardSelector = createSelector(getBoards, boards =>
  boards.find(({ is_custom }) => is_custom)
);
